import { MCPRegistrationConfig } from "./mcp-registration";
import { getPublicFreeTrialDays } from "@blueskydataplatform/shared-ui/config/public-runtime-config";
import { BellRing, Database, LayoutDashboard, Wand2 } from "lucide-react";

const trialDays = getPublicFreeTrialDays();

export const DEFAULT_PROVIDER_CONFIG: MCPRegistrationConfig = {
  providerName: "viaNexus",
  trialDays,
  holdings: (
    <>
      Full access to <strong>30+ institutional datasets</strong> — prices, fundamentals, news, transcripts, estimates
      and indices — on <strong>any symbol you like</strong>, for the next {trialDays} days.
    </>
  ),
  starterPrompts: [
    "What can I do with my viaNexus subscription?",
    "Compare NVDA, ASML and TSM on revenue growth and valuation.",
    "Alert me when MSFT's 50-day crosses below its 200-day.",
  ],
  pillarsHeading: "What you just unlocked",
  pillars: [
    {
      icon: Database,
      title: "Data",
      tagline: "30+ institutional datasets",
      description:
        "MT Newswires, Aiera, BMLL, ExtractAlpha, IndexOne and viaNexus CORE. Today you have all of them, on any symbol.",
      examplePrompt: "Show me Tesla's revenue and margin trend over the last 8 quarters.",
      link: { label: "Browse the catalog", href: "/catalog" },
    },
    {
      icon: Wand2,
      title: "Skills",
      tagline: "Ready-made research workflows",
      description:
        "Equity research briefings, real-time news, earnings-call breakdowns and a daily portfolio brief — each one a prompt you can rerun any time.",
      examplePrompt: "Give me my morning portfolio brief for AAPL, MSFT and NVDA.",
      link: { label: "Browse skills", href: "https://github.com/blueskynexus/claude-skills" },
    },
    {
      icon: BellRing,
      title: "Alerts",
      tagline: "It watches, you don't",
      description: "Ask for a price, a moving-average crossover or a dividend to be tracked. You get an email.",
      examplePrompt: "Email me if NVDA drops more than 5% in a single day.",
    },
    {
      icon: LayoutDashboard,
      title: "Apps",
      tagline: "Single-file dashboards, built on request",
      description:
        "Builder skills for a live watchlist dashboard, an RSI momentum board and an earnings calendar — and anything else you describe. No backend, no build step.",
      examplePrompt: "Build me a live dashboard for AAPL, NVDA and AMD with sparklines and news.",
    },
  ],
  video: {
    title: "How viaNexus connectors work in Claude",
    description:
      "How the connector talks to your client, and how agent-level permissioning keeps each agent to the data you allow.",
    href: "https://www.youtube.com/watch?v=a5gf-FnX4zU",
    thumbnailUrl: "https://i.ytimg.com/vi/a5gf-FnX4zU/hqdefault.jpg",
  },
  docs: {
    title: "How viaNexus works",
    description:
      "vAST is the access layer behind your connector: one signed credential, every dataset, and permissions enforced server-side for each agent.",
    href: "https://vianexus.com/vast/",
  },
  afterTrialNote: `For the next ${trialDays} days there are no symbol limits — use the whole platform. After that, choose the datasets and the symbol universe you want; that's how you keep the cost to what you actually use. Nothing is charged automatically.`,
  supportEmail: "support@viaNexus.com",
};
